var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSidebar = function SvgSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.833 1.667H4.167A4.17 4.17 0 0 0 0 5.834v8.333a4.17 4.17 0 0 0 4.167 4.167h11.666A4.17 4.17 0 0 0 20 14.167V5.834a4.17 4.17 0 0 0-4.167-4.167m-14.166 12.5V5.834c0-1.379 1.121-2.5 2.5-2.5H7.5v13.333H4.167a2.503 2.503 0 0 1-2.5-2.5m16.666 0c0 1.378-1.121 2.5-2.5 2.5H9.167V3.334h6.666c1.379 0 2.5 1.121 2.5 2.5zm-12.5-5c0 .46-.372.833-.833.833h-.833a.833.833 0 1 1 0-1.666H5c.46 0 .833.372.833.833m0 3.333c0 .461-.372.834-.833.834h-.833a.833.833 0 1 1 0-1.667H5c.46 0 .833.373.833.833m-2.5-6.666c0-.461.373-.834.834-.834H5a.833.833 0 1 1 0 1.667h-.833a.833.833 0 0 1-.834-.833"
  })));
};
export default SvgSidebar;